import { Alert, AlertProps } from "../lib";
import { createStyles } from "../theme";

type Props = Omit<AlertProps, "clamp" | "small">;

export function Banner({ variant = "info", ...rest }: Props) {
  return <Alert {...rest} small variant={variant} style={$.container} />;
}

const $ = createStyles({
  container: {
    borderRadius: 0,
  },
});
